export const formatItem = (item: APICustomField) => {
  const {
    id,
    object_type,
    title,
    description,
    field_type,
    config,
    created_by,
    archived_at,
    created_at,
    updated_at,
    options
  } = item

  const formatted: LocalCustomField = {
    id,
    object_type,
    title,
    description,
    field_type,
    config,
    created_by: created_by ?? '',
    archived_at,
    created_at,
    updated_at,
    options
  }

  return formatted
}
